import Types from '../reducers/app/types';
import {dispatch} from './store';

let connection = null,
    connection_type = null;

let state = {
    initialized: false,
    authorized: false,
    walletId: null
}

const log = log => console.log(`[WS] ${log}`),
      send = data => connection.send(JSON.stringify(data));

const connect = () => {
    connection = new WebSocket(`${window.location.origin.replace('http', 'ws')}/ws`);

    connection.onopen = () => {
        log(`Connection open`);

        if(!state.authorized && state.walletId)
            authorize();
    }

    connection.onmessage = res => {
        try {
            res = JSON.parse(res.data);
        } catch(e) {
            return log(`Wrong response`, res);
        }

        switch(res.type) {
            case 'cashback':
                return dispatch({
                    type: Types.cashback,
                    payload: res.payload
                });
            case 'verification':
                return dispatch({
                    type: Types.verification,
                    payload: res.payload
                });
            case 'tasks':
                return dispatch({
                    type: Types.tasks,
                    payload: res.payload
                })
            case 'transaction':
                return dispatch({
                    type: Types.transaction,
                    payload: res.payload
                });
            case 'balance':
                return dispatch({
                    type: Types.balance,
                    payload: res.payload
                });
            case 'hello':
                return window.alert('CALL');
            case 'authorized':
                state.authorized = true;
                return log(`Successfully logged in [${connection_type}]`);
            case 'unauthorized':
                return log(`Successfully logout`);
        }
    }

    connection.onclose = () => {
        log('Connection closed')

        state.authorized = false;
        return setTimeout(connect, 3e3);
    }
}

function init() {
    if(state.initialized)
        return;

    state.initialized = true;
    connect();
}

function logout() {
    if(!connection || connection.readyState !== WebSocket.OPEN)
        return setTimeout(logout, 1e3);

    state.authorized = false;
    state.walletId = null;

    send({
        type: 'logout'
    });
}

function authorize(walletId=false) {
    if(!connection || connection.readyState !== WebSocket.OPEN)
        return setTimeout(authorize, 1e3, walletId);

    if(state.authorized)
        return;

    if(!state.walletId && !walletId)
        return;

    if(walletId)
        state.walletId = walletId;

    send({
        type: 'authorize',
        payload: state.walletId
    });
}

export default {
    init,
    authorize,
    logout
}